<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import OrgChartNode from "./OrgChartNode.vue";

export default {
    name: "OrgChartNode",
    components: {
        SpellCheckedText,
        PhotoBox,
		OrgChartNode,
    },
    props: {
        node: { type: Object, required: true },
        variant: { type: String, default: 'box' }
    },
    computed: {
	member: {
    get() {
      return {
        teamMemberName: "",
        role: "",
        ...this.node,
        ...(this.node.sourceMember || {})
      };
    },
    set(updated) {
      if (this.node.sourceMember) {
        Object.assign(this.node.sourceMember, updated);
      } else {
        Object.assign(this.node, updated);
      }
    }
  }
 }
};
</script>

<template>
    <li>
        <div class="node-card">
            <div class="photobox" :class="['node-image', variant]">
                <PhotoBox :project="member" type="profile" :bgColor="'#f0f0f0'" objectFit="cover" />
            </div>
            <div :class="['node-details', variant]">
                <h4 class="member-name">
                    <SpellCheckedText :value="member.teamMemberName || ''" @input="member.teamMemberName = $event" />
                </h4>
                <p class="member-role">
                    <SpellCheckedText :value="member.role || ''" @input="member.role = $event" />
                </p>
            </div>
        </div>

        <ul v-if="node.children && node.children.length > 0">
            <OrgChartNode v-for="child in node.children" :key="child.teamMemberId" :node="child" :variant="variant" />
        </ul>
    </li>
</template>

<style scoped lang="scss">
.node-card {
  display: inline-block;
  width: 110px;
  position: relative;
  z-index: 1;

  .node-image {
    width: 100%;
    background: #f0f0f0;
    overflow: hidden;

    &.box {
      height: 110px;
      border-radius: 0px;
    }

    &.circular {
      height: 110px;
      border-radius: 50%;
    }
  }

  .node-details {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 8px 4px;
    min-height: 55px;

    &.box {
        background: var(--body-color);
     }
    &.circular {
      background: var(--body-color);
    }

    .member-name {
      color: var(--label-color);
      font-size: var(--label-size);
      font-weight: var(--label-weight);
      font-family: var(--label-font);
      font-style: var(--label-style);
      text-decoration: var(--label-decoration);
      margin: 0;
      line-height: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .member-role {
      color: var(--text-color);
      font-size: var(--text-size);
      font-weight: var(--text-weight);
      font-family: var(--text-font);
      font-style: var(--text-style);
      text-decoration: var(--text-decoration);
      margin: 2px 0 0;
      line-height: 1.2;
    }
  }
}
.tree-container {
    width: 100%;
    display: flex;
    justify-content: center;
}

.tree {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 0;
    margin: 0;

   ul {
        padding-top: 10px;
        position: relative;
        display: flex;
        justify-content: center;
        padding-left: 0;
        margin: 0;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            border-left: 1px solid #777;
            width: 0;
            height: 10px;
        }
    }

   li {
        text-align: center;
        list-style-type: none;
        position: relative;
        padding: 10px 5px 0 5px;

        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: 50%;
            border-top: 1px solid #777;
            width: 50%;
            height: 30px;
        }

        &::after {
            right: auto;
            left: 50%;
            border-left: 1px solid #777;
        }

        &:only-child::after,
        &:only-child::before {
            display: none;
        }

        &:only-child {
            padding-top: 0;
        }

        &:first-child::before,
        &:last-child::after {
            border: 0 none;
        }

        &:last-child::before {
            border-right: 1px solid #777;
            border-radius: 0 5px 0 0;
        }

        &:first-child::after {
            border-radius: 5px 0 0 0;
        }
    }
}
</style>
